import { defineComponent } from "vue";
import ThemesHelper from "@/helpers/ThemesHelper";
import moment from "moment";

export default defineComponent({
  props: {
    userName: {
      type: String,
    },
  },
  data() {
    return {
      logoPath: ThemesHelper.getUrlImage("urlPathLogoFile"),
      currentDate: moment().format("DD/MM/YYYY"),
    };
  },
});
